export enum GlycerinAvailability {
  IMMEDIATELY = 'AvailabilityType.IMMEDIATELY',
  NOTIMMEDIATELY = 'AvailabilityType.NOTIMMEDIATELY',
  UNAVAILABLE = 'AvailabilityType.UNAVAILABLE',
  UNKNOWN = 'AvailabilityType.UNKNOWN',
}

export enum GlycerinRatingStatus {
  RATED = 'RatingStatus.RATED',
  UNAVAILABLE = 'RatingStatus.UNAVAILABLE',
  UNRATED = 'RatingStatus.UNRATED',
}

export enum GlycerinPlacement {
  HEADER = 'Placement.HEADER',
  CONTENT = 'Placement.CONTENT',
  FOOTER = 'Placement.FOOTER',
  OVERLAY = 'Placement.OVERLAY',
  LISTING = 'Placement.LISTING',
}

export enum GlycerinVideoAction {
  PLAY = 'VideoAction.PLAY',
  PAUSE = 'VideoAction.PAUSE',
}

export enum GlycerinLoginStatus {
  SOFTLOGGEDIN = 'LoginStatus.SOFTLOGGEDIN',
  LOGGEDIN = 'LoginStatus.LOGGEDIN',
  UNKNOWN = 'LoginStatus.UNKNOWN',
}

export enum GlycerinFilterType {
  MULTISELECT = 'FilterType.MULTISELECT',
  RANGE = 'FilterType.RANGE',
  SINGLESELECT = 'FilterType.SINGLESELECT',
}

export enum GlycerinTileType {
  PRODUCT = 'TileType.PRODUCT',
  AD = 'TileType.AD',
  CAMPAIGN = 'TileType.CAMPAIGN',
}

export enum GlycerinSortMethod {
  NEW = 'SortMethod.NEW',
  DISCOUNT = 'SortMethod.DISCOUNT',
  OTHER = 'SortMethod.OTHER',
  POPULARITY = 'SortMethod.POPULARITY',
  PRICEASCENDING = 'SortMethod.PRICEASCENDING',
  PRICEDESCENDING = 'SortMethod.PRICEDESCENDING',
  RATING = 'SortMethod.RATING',
  SEARCHLOGIC = 'SortMethod.SEARCHLOGIC',
  PRANK = 'SortMethod.PRANK',
}

export enum GlycerinDestinationType {
  REGULAR = 'DestinationType.REGULAR',
  STOREPICKUP = 'DestinationType.STOREPICKUP',
  PARCELSHOP = 'DestinationType.PARCELSHOP',
  PARCELSTATION = 'DestinationType.PARCELSTATION',
  EMAIL = 'DestinationType.EMAIL',
}

export enum GlycerinPaymentType {
  OTHER = 'PaymentType.OTHER',
  INVOICE = 'PaymentType.INVOICE',
  CREDITCARD = 'PaymentType.CREDITCARD',
  PAYPAL = 'PaymentType.PAYPAL',
  PREPAYMENT = 'PaymentType.PREPAYMENT',
  DEBIT = 'PaymentType.DEBIT',
  DEFERREDPAYMENT = 'PaymentType.DEFERREDPAYMENT',
  SOFORTUEBERWEISUNG = 'PaymentType.SOFORTUEBERWEISUNG',
  KLARNA = 'PaymentType.KLARNA',
  RATEPAY = 'PaymentType.RATEPAY',
  AMAZONPAY = 'PaymentType.AMAZONPAY',
  GOOGLEPAY = 'PaymentType.GOOGLEPAY',
  PAYDIREKT = 'PaymentType.PAYDIREKT',
  STOREPAYMENT = 'PaymentType.STOREPAYMENT',
  GIROPAY = 'PaymentType.GIROPAY',
  VOUCHER = 'PaymentType.VOUCHER',
  CASHONDELIVERY = 'PaymentType.CASHONDELIVERY',
  INSTALLMENT = 'PaymentType.INSTALLMENT',
}

export enum GlycerinShippingType {
  REGULAR = 'ShippingType.REGULAR',
  EXPRESS = 'ShippingType.EXPRESS',
  PREFERREDTIMEOFDELIVERY = 'ShippingType.PREFERREDTIMEOFDELIVERY',
  FLATRATE = 'ShippingType.FLATRATE',
}

export enum GlycerinErrorSeverity {
  WARNING = 'Severity.WARNING',
  CRITICAL = 'Severity.CRITICAL',
}

export enum GlycerinSuggestionType {
  PRODUCT = 'SuggestionType.PRODUCT',
  CATEGORY = 'SuggestionType.CATEGORY',
  TERM = 'SuggestionType.TERM',
}
